import React, { useState } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import Home from './components/pages/Home';
import Layout from './components/layouts/Layout';
// import SrpEnglish from './components/pages/english/SrpEnglish';
import Tutorial from './components/pages/in/Tutorial';
import TermService from './components/pages/in/TermService';
import SelfRegistration from './components/pages/in/SelfRegistration';
// import PersonalTermService from './components/pages/in/TermPrivacyProtection';
import DocumentChoose from './components/pages/in/DocumentChoose';
import DocumentPhoto from './components/pages/in/DocumentPhoto';
// import DocumentPreview from './components/pages/in/DocumentPreview';
import DocumentWithSelfie from './components/pages/in/DocumentWithSelfie';
// import DocumentSelfiePreview from './components/pages/in/DocumentWithSelfiePreview';
import Selfie from './components/pages/in/Selfie';
import PersonalInfo from './components/pages/in/PersonalInfo';
import ThanksPage from './components/pages/in/ThanksPage';
import RegistrationResult from './components/pages/in/RegistrationResult';
import RegistrationSuccessful from './components/pages/in/RegistrationSuccessful';
// import WebcamCapture from './components/pages/WebcamCaptureSelfieDelete';
import Faq from './components/pages/in/Faq';
import Contact from './components/pages/in/Contact';
import TermUse from './components/pages/in/TermUse';
import TermPrivacyProtection from './components/pages/in/TermPrivacyProtection';
import VideoKYC from './components/pages/in/VideoKYC';
import AppointmentComponent from './components/pages/in/ScheduleVkycComponent';
import ScheduleVkyc from './components/pages/in/ScheduleVkycComponent';

// ----------------------------------------------------------------------
/**
 * return routing paths
 * @return  {array}  routing object
 */
function Router() {
  const [showSkip, setShowSkip] = useState(Boolean);
  const [languages, setLanguages] = useState([]);
  const [vkycStatus, setVkycStatus] = useState(null);
  // console.log('showSkip', showSkip);

  return useRoutes([
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/login'
      // element: <Login />
    },
    // {
    //   path: '/camera-document-front',
    //   element: <WebcamCaptureDocFront />
    // },
    // {
    //   path: '/camera-document-with-selfie',
    //   element: <WebcamCaptureDocWithSelfie />
    // },
    // {
    //   path: '/camera-selfie',
    //   element: <WebcamCaptureSelfieDelete />
    // },
    {
      path: '/in',
      element: <Layout showSkip={showSkip} languages={languages} vkycStatus={vkycStatus} />,
      children: [
        { path: '', element: <Tutorial setShowSkip={setShowSkip} /> },
        // { path: 'en', element: <SrpEnglish /> },
        // { path: 'in', element: <Tutorial /> },
        {
          path: 'selfregistration',
          element: (
            <SelfRegistration
              setLanguages={setLanguages}
              vkycStatus={vkycStatus}
              setVkycStatus={setVkycStatus}
            />
          )
        },
        { path: 'faq', element: <Faq /> },
        { path: 'contact', element: <Contact /> },
        { path: 'terms-of-use', element: <TermUse /> },
        { path: 'terms-of-service', element: <TermService /> },
        { path: 'terms-of-privacy-protection', element: <TermPrivacyProtection /> },
        { path: 'document-choose', element: <DocumentChoose /> },
        { path: 'document-photo', element: <DocumentPhoto /> }, // used
        { path: 'document-with-selfie', element: <DocumentWithSelfie /> },
        // { path: 'document-with-selfie-preview', element: <DocumentWithSelfiePreview /> },
        { path: 'face-selfie', element: <Selfie /> },
        { path: 'personal-info', element: <PersonalInfo /> },
        { path: 'thanks', element: <ThanksPage /> },
        { path: 'schedule-vkyc', element: <ScheduleVkyc /> },
        { path: 'video-kyc', element: <VideoKYC /> },
        { path: 'registration-result', element: <RegistrationResult /> },
        { path: 'registration-successful', element: <RegistrationSuccessful /> },
        { path: '*', element: <Navigate to="/" /> }
      ]
    },
    { path: '*', element: <Navigate to="/" replace /> }
  ]);
}
export default Router;
